import React, { useState, useMemo, useEffect } from "react";
import Styles from "../../../../src/styles/selectionBlock.module.scss";
import { amountFormatter } from "../../../utility/utils/formatter";
import { easyPayCalculate } from "../../../utility/features/helpers/accountHelper";
import { useDispatch, useSelector } from "react-redux";
import { AllAccountDetailsClient } from "../../../utility/apiClients/account/accountDetailsClient";
import { useLocation } from "react-router";
import $ from "jquery";
import { set } from "react-hook-form";
import { object } from "yup";
import {setEasyPayEnrollAgrNum} from "../../../reduxStore/myAccount/accountSummarySlice";

const SelectionBlock = ({ paymentData, setHasSelection, ref, isPaymentSubmitted }) => {
  const loc = useLocation();
  const path = loc.pathname;
  
  const [services, setServices] = useState([]);
  const selectedEasyPayEnrollAgrNum = useSelector((state) => state.accountSummary.easyPayEnrollAgrNum);
  useEffect(() => {
    setServices(
      paymentData?.easyPaySvcAg ||
        paymentData?.nonEasyPaySvcAg ||
        paymentData ||
        []
    );
    
  }, [paymentData]);

  const [checkedMap, setCheckedMap] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const dispatch = useDispatch();
  
  const selectedServiceAddress = useSelector(
    (state) => state.accountSummary.selectedServiceAddress
  );
  const getServiceKey = (s) => s.salesAgrNum;

  useEffect(() => {
    if(services.length > 0){
      if(path.includes("payments/enroll") && selectedEasyPayEnrollAgrNum.length > 0){
        const AgrNumArr = selectedEasyPayEnrollAgrNum || [];
        const allChecked = {};
        services.forEach((s) => {
          if(AgrNumArr.indexOf(s.salesAgrNum) !== -1){
            allChecked[getServiceKey(s)] = true;
          }
        });
        if(services.length == AgrNumArr.length){
          setSelectAll(true);
        }
        setCheckedMap(allChecked);
        setHasSelection(true);
        // unset state
        dispatch(setEasyPayEnrollAgrNum([]));
      } else if(!path.includes("payments/enroll")) {
        const allChecked = {};
        services.forEach((s) => {
          allChecked[getServiceKey(s)] = true;
        });
        setSelectAll(true);
        setCheckedMap(allChecked);
        setHasSelection(true);
      }
    }
  }, [services]);

  const handleServiceClick = (id) => {
    setSelectAll(false);
    const newmapChecked = { ...checkedMap, [id]: !checkedMap[id] };

    setCheckedMap(newmapChecked);
    const checkedCount = newmapChecked ? Object.values(newmapChecked).filter(Boolean).length : 0;
    setHasSelection(checkedCount > 0);
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    
    setSelectAll(newSelectAll);

    const allChecked = {};
    if (newSelectAll) {
      services.forEach((s) => {
        allChecked[getServiceKey(s)] = true;
      });
      
      setCheckedMap(allChecked);
      
    } else {
      setCheckedMap({});
    }
    const checkedCount = allChecked ? Object.values(allChecked).filter(Boolean).length : 0;
    setHasSelection(checkedCount > 0);
    
  };

  ref.current = checkedMap;
    
  const total = useMemo(() => {
    return services.reduce((sum, s) => {
      const key = getServiceKey(s);
      return checkedMap[key] ? sum + (s.AveragePricePerService || 0) : sum;
    }, 0);
  }, [checkedMap, services]);

  useEffect(() => {

    if (!services || services.length === 0) {
      const cusNum = selectedServiceAddress?.split("|")[1]?.trim();
      const ifNoCustomerNumber = JSON.parse(
        localStorage.getItem("serviceAddressesWithCustomerNumbers")
      );
      let forCheck = ifNoCustomerNumber
        ?.filter((val) => val.includes(cusNum))[0]
        ?.split("|")[0]
        .trim();
      const serviceAddress = selectedServiceAddress?.split("|")[0]?.trim();
    }

    const paymentList = services
      .filter((s) => checkedMap[getServiceKey(s)])
      .map((s) => ({
        id: getServiceKey(s),
        name: s.svcLineDesc,
        price: s.AveragePricePerService,
      }));

    const checkedData = [{ successData: [], listData: paymentList }];
    
    if(!isPaymentSubmitted)
      sessionStorage.setItem("paymentlist", JSON.stringify(checkedData));
  }, [checkedMap, services, selectedServiceAddress]);

  return (
    <>
      <div className={`${Styles["mb-20"]} row`}>
        <div className='col-12'>
          <div className='align-items-center d-flex'>
            <div>
              <input 
                type='checkbox' 
                className={`${Styles["mr-10"]} ${Styles["select-all-check"]}`} 
                onChange={handleSelectAll} 
                checked={selectAll} 
              />
            </div>
            <label className={`${Styles["gfs-20"]} ${Styles["gfw-3"]} ${Styles["m-0"]} ${Styles["select-all-label"]} d-block`} htmlFor='selectAllCheckbox'>Select All</label>
          </div>
        </div>
      </div>

      {(services || paymentData).map((service, i) => {
        const key = getServiceKey(service);
        const avgprice = amountFormatter(
          Number(service.AveragePricePerService || 0)
        );
        const isChecked = !!checkedMap[key];

        return (
          <div className='row' key={key}>
            <div className={`col-12 ${Styles["tru-mma-main-content-box"]}`}>
              <div className={`row ${Styles["border-bottom"]} ${Styles["mb-20"]} ${Styles["mb-md-0"]}`}>
                <div className={`align-items-center ${Styles["border-bottom"]} col-12 col-md-8 col-lg-9 d-flex ${Styles["gfw-3"]} ${Styles["p-30"]} pref-service text-center ${Styles["text-md-left"]}`}>
                  <div className='d-flex align-items-center gap-1'>
                    <div>
                      <input
                        type='checkbox'
                        name='service-single-select'
                        checked={isChecked}
                        onChange={() => handleServiceClick(key)}
                      />
                    </div>
                    <label className={`${Styles["gfs-24"]} ${Styles["gfw-3"]} ${Styles["glh-1"]} ${Styles["m-0"]} ${Styles["select-all-label"]} d-block`} htmlFor='service-single-select'>{service.svcLineDesc}</label>
                  </div>
                </div>
                <div className={`${Styles["bg-white"]} col-12 col-md-4 col-lg-3 d-flex flex-column justify-content-end text-center text-lg-left p-0 ${Styles["tru-mma-main-side"]} d-block`}>
                  <div className={`align-items-center d-flex flex-column flex-fill justify-content-center ${Styles["p-10"]}`}>
                    <span className={`d-block ${Styles["gfs-14"]} ${Styles["gfs-lg-16"]}`}>Average price per service<sup>*</sup></span>
                    <span className={`d-block ${Styles["gfs-50"]} ${Styles["gfs-md-40"]} ${Styles["gfw-7"]} ${Styles["glh-1_2"]} ${Styles["text-green"]}`}>
                      <span>${avgprice.dollars}</span>
                      <sup className={`${Styles["gfs-26"]} ${Styles["gfs-md-22"]} ${Styles["tg-ml-6"]}`}>{avgprice.cents}</sup>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      <div className={`d-flex justify-content-end row ${Styles["mb-20"]}`}>
        <div className='col-12 col-md-4 col-lg-3 p-0'>
          <span className={`${Styles["gfs-12"]} ${Styles['gfw-3']}`}>*Your actual payment may vary based on the phase of your service.</span>
        </div>
      </div>
    </>
  );
};

export default SelectionBlock;
